module.exports = __webpack_public_path__ + "img/platform-logo-default.9427dda4.png";